import { TextField, Toolbar, Typography } from '@mui/material';
import { getArchiveSearchListApi } from 'api/meeting';
import { useState } from 'react';

function ArchiveDataTableToolbar({ pageTitle, setData, setLoading, setSearchType, setToolbarPayload }) {
    const [searchText, setSearchText] = useState("");

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter') {
            try {
                setLoading(true);
                const res = await getArchiveSearchListApi({ searchText });
                setData(res.data);
                setToolbarPayload({ searchText });
                setSearchType("toolbar");
                setLoading(false);
            } catch (error) {
                console.error("Arama sırasında hata oluştu:", error);
            }
        }
    };

    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'space-between', gap: 2 }}>
            <Typography variant="h6">{pageTitle}</Typography>
            <TextField
                id="searchText1xe"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleKeyDown}
                margin="dense"
                label="Arama Yap"
                className="mr-4"
                sx={{ flexGrow: 1, background: 'white' }}
                placeholder="Bilgi"
            />
        </Toolbar>
    );
}

export default ArchiveDataTableToolbar;
